import { Sort } from './sort';
/**
 * Sort domain of x scale of mark groups by groups.
 */
export const SortColor = (options = {}) => {
    return Sort(Object.assign(Object.assign({}, options), { channel: 'color' }));
};
SortColor.props = {};
//# sourceMappingURL=sortColor.js.map